const state = {
  rootUrl: undefined
}

export default {
  namespaced: true,
  state,
  actions: {},
  getters: {},
  mutations: {
    ROOTURL_UPDATED: (state, url) => { state.rootUrl = url }
  }
}
